import { CameraInteractionAction, CameraTooltipType } from './types';

/**
 * Required map field status codes used by the `/api/v1/map` theme contract.
 */
export const MAP_STATUS_CODES = ['GREEN', 'YELLOW', 'RED', 'WHITE'] as const;

/**
 * Required tooltip debt-state codes used by the `/api/v1/map` theme contract.
 */
export const TOOLTIP_DEBT_STATES = ['debt', 'overpayment', 'unknown', 'no_debt'] as const;

/**
 * Required top-level street theme groups used by the `/api/v1/map` theme contract.
 */
export const MAP_STREET_THEME_GROUPS = ['default'] as const;

/**
 * Required camera popup types used by the `/api/v1/map` camera tooltip contract.
 */
export const CAMERA_TOOLTIP_TYPES = [
  CameraTooltipType.Public,
  CameraTooltipType.Restricted,
  CameraTooltipType.Inactive,
] as const;

/**
 * Required camera click actions used by the `/api/v1/map` camera interaction contract.
 */
export const CAMERA_INTERACTION_ACTIONS = [
  CameraInteractionAction.None,
  CameraInteractionAction.OpenCameras,
  CameraInteractionAction.ShowLoginRequiredDialog,
] as const;

/**
 * Required tokens for one map status theme item.
 */
export const MAP_STATUS_THEME_TOKEN_KEYS = ['fillColor', 'stroke', 'textColor'] as const;

/**
 * Required tokens for one tooltip theme item.
 */
export const TOOLTIP_THEME_TOKEN_KEYS = ['surfaceColor', 'borderColor', 'debtTextColor'] as const;

/**
 * Required tokens for one street theme item.
 */
export const MAP_STREET_THEME_TOKEN_KEYS = ['textColor'] as const;

/**
 * Required tokens for one camera popup theme item.
 */
export const CAMERA_TOOLTIP_THEME_TOKEN_KEYS = [
  'surfaceColor',
  'borderColor',
  'textColor',
] as const;

/**
 * Base width/height of one camera SVG icon before applying API `sizeMultiplier`.
 */
export const MAP_CAMERA_BASE_ICON_SIZE = 24;

/**
 * Original camera icon viewport size from the source SVG.
 */
export const CAMERA_ICON_VIEWBOX_SIZE = 488.3;
